import type {
  TConversationControllerState,
  TConversationListState,
} from "./conversation.types";

export const conversationControllerInitialState: TConversationControllerState = {
  active: undefined,
  chatType: undefined,
  empty: { from: true, to: true },
  status: { from: "idle", to: "idle" },
  hasOlderChats: { from: undefined, to: undefined },
  unreadChats: { from: 0, to: 0 },
  selectedTags: [],
};

export const conversationListInitialState: TConversationListState = {
  idle: true,
  error: false,
  fetched: false,
  loading: false,
  updated: false,
  source: [],
};
